import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { disconnectPeerHandler } from './disconnectPeerHandler';
import { errorPeerConnectHandler } from './errorPeerConnectHandler';
import { inMsgHandler } from './inMsgHandler';
import { loginSuccessHandler } from './loginSuccessHandler';
import { onP2PErrorHandler } from './onP2PErrorHandler';
import { onP2POpenHandler } from './onP2POpenHandler';
import { peerConnectedHandler } from './peerConnectedHandler';
import { peerFoundHandler } from './peerFoundHandler';
import { requestJoinHandler } from './requestJoinHandler';
import { userAddedToWhiteListHandler } from './userAddedToWhiteListHandler';

let socket: WebSocket | null = null;

let reconnectInterval: any | null = null;

export const connectP2PSocket = (socketServerUrl: string): void => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close();
        socket = null;
    }

    if (!socket || socket.readyState === WebSocket.CLOSED) {
        socket = new WebSocket(socketServerUrl);

        socket.onopen = () => {
            onP2POpenHandler();
        };

        socket.onmessage = e => {
            const { event, data, source } = JSON.parse(e.data);

            const eventRec = data?.event ?? event;
            const dataRec = data?.data ?? data;

            switch (eventRec) {
                case 'login':
                    loginSuccessHandler(dataRec);
                    break;
                case 'available':
                    break;
                case 'peer':
                    peerFoundHandler(dataRec);
                    break;
                case 'connected':
                    peerConnectedHandler();
                    break;
                case 'request-join':
                    requestJoinHandler(dataRec);
                    break;
                case 'in_msg':
                    inMsgHandler(dataRec, source);
                    break;
                case 'whitelist_user_added':
                    userAddedToWhiteListHandler(data);
                    break;
                case 'user_left':
                    store.dispatch(
                        p2pActions.removeWaitingUser(data.connection_id),
                    );
                    break;
                case 'disconnect_peer':
                    disconnectPeerHandler();
                    break;
                case 'error_peer':
                    errorPeerConnectHandler();
                    break;
            }
        };

        socket.onerror = (event: Event) => {
            onP2PErrorHandler(event);
        };

        socket.onclose = event => {
            store.dispatch(p2pActions.updatePeerFound('No Connection'));
            store.dispatch(p2pActions.updateP2PSConnection(false));
            store.dispatch(p2pActions.setAvailableCondition(false));
            if (event.code === 1000) {
                console.log('WebSocket connection closed by user.');
            } else {
                reconnectInterval = setTimeout(() => {
                    if (socket?.readyState === WebSocket.CLOSED) {
                        restartP2PSocket(socketServerUrl);
                        console.log('try to connect');
                    }
                }, 15000);
            }
        };
    } else if (socket.readyState === WebSocket.CONNECTING) {
        console.log('connecting in progress');
    } else {
        socket.close();
        socket = null;
    }
};

export const closeP2PSocket = (): void => {
    if (socket) {
        socket.close(1000, 'Connection closed by user.');
        socket = null;
    } else {
        console.log('No Socket available');
    }
};

export const restartP2PSocket = (socketServerUrl: string): void => {
    if (socket) {
        socket = null;
        clearTimeout(reconnectInterval);
        connectP2PSocket(socketServerUrl);
    }
};

export const sendP2PSocketData = (data: any): { socketSentData: any } => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(data));
    } else {
        console.error(
            'WebSocket not open:',
            data,
            socket,
            socket?.readyState === WebSocket.OPEN,
        );
    }

    return {
        socketSentData: data,
    };
};

export const isP2PSocketConnected = (): boolean => {
    return socket && socket?.readyState === WebSocket.OPEN;
};
